export default __webpack_public_path__ + "static/media/witten3.5925a93b.png";